export const isFeatureFlagEnabled = (accountConfig, featureFlagName) => accountConfig?.[featureFlagName] === 'true';
export const isUserPermissionOrFeatureFlagEnabled = ({
    permissionsMap,
    accountConfig,
    requiredPermission,
    featureFlagName,
}) => permissionsMap[requiredPermission] || isFeatureFlagEnabled(accountConfig, featureFlagName);
